<template>
  <div>
    <div
      :class="[
        smallSpinner ? 'style-small-spinner' : 'style-normal-spinner',
        'scss-bold',
      ]"
    >
      <div class="d-flex flex-row">
        <!-- Minus Button -->
        <i
          @click="minusQuantity"
          class="bi bi-dash-circle input-spinner-btn scss-click-effect"></i>

        <!-- Quantity -->
        <div
          class="d-flex align-items-center justify-content-center input-spinner-content flex-grow-1"
        >
          {{ quantity }}
        </div>

        <!-- Add Button -->
        <i
          @click="addQuantity"
          class="bi bi-plus-circle input-spinner-btn scss-click-effect"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";

export default {
  props: {
    id: [Number, String],
    quantity: {
      Number,
      required: true,
    },
    smallSpinner: Boolean,
  },
  methods: {
    addQuantity() {
      this.$emit("update:quantity", this.quantity + 1, this.id);
    },
    minusQuantity() {
      if (this.quantity > 1) {
        this.$emit("update:quantity", this.quantity - 1, this.id);
      } else {
        useToast().error("Minimum quantity is 1 unit.");
      }
    },
  },
};
</script>
<style scoped lang="scss">
/* Style for normal input spinner */
.style-normal-spinner {
  .input-spinner-content {
    color: $normal-font-color;
    font-size: 24px;
  }
  .input-spinner-btn {
    width: 10vh;
    font-size: 28px;
  }
  @media (max-width: 512px) {
    .input-spinner-btn {
      width: 9vh;
    }
  }
}

/* Style for small Input Spinner */
.style-small-spinner {
  .input-spinner-content {
    color: $normal-font-color;
    font-size: 15px;
    width: 40px;
  }
  .input-spinner-btn {
    font-size: 26px;
    width: 30px;
    height: 34px;
    border-radius: 34px;
  }
}
.style-quantity {
  visibility: hidden;
  width: 0px;
  height: 0px;
  position: absolute;
}
</style>
